import { render } from "./AllAppointmentLabs.vue?vue&type=template&id=a926a2b2&scoped=true"
import script from "./AllAppointmentLabs.vue?vue&type=script&lang=js"
export * from "./AllAppointmentLabs.vue?vue&type=script&lang=js"

import "./AllAppointmentLabs.vue?vue&type=style&index=0&id=a926a2b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a926a2b2"]])

export default __exports__